import { FC } from "react";
import { styled } from "@mui/material";
import { Link } from "react-router-dom";
import { MenuItem } from "types";
import Button from "@mui/material/Button";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import EmailIcon from "@mui/icons-material/Email";
import SmsIcon from "@mui/icons-material/Sms";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

type Props = {
  menu: MenuItem[];
  isButtonDisabled: boolean;
  onSendEmailClick?: () => void;
  onSendSMSClick?: () => void;
  setOpen: (arg: boolean) => void;
  handleDownload: () => void;
};

const ActionList: FC<Props> = ({
  menu,
  isButtonDisabled,
  onSendEmailClick,
  onSendSMSClick,
  setOpen,
  handleDownload,
}): any => {
  const actions = menu.find((menuItem: MenuItem) => menuItem.id === "Survey")?.actions ?? [];
  return actions.map((action) => {
    switch (action.actionID) {
      case "Person.Add":
        return (
          <>
            {/* Disabling Add button for now */}
            {/* <ButtonStyled type='button' variant='outlined' startIcon={<PersonAddAltIcon />}>
              <Link to='/survey/user-create' key={action?.actionID}>
                Agregar Encuestado
              </Link>
            </ButtonStyled> */}
            <ButtonStyled type='button' variant='outlined' startIcon={<AttachFileIcon />} onClick={() => setOpen(true)}>
              Cargar Archivo
            </ButtonStyled>
            <ButtonStyled type='button' variant='outlined' startIcon={<CloudDownloadIcon />} onClick={handleDownload}>
              Descargar Plantilla
            </ButtonStyled>
          </>
        );
      case "Survey.SendByEMail":
        return (
          <ButtonStyled
            type='button'
            variant='outlined'
            key={action?.actionID}
            startIcon={<EmailIcon />}
            onClick={onSendEmailClick}
            disabled={isButtonDisabled as boolean}
          >
            Enviar Correo
          </ButtonStyled>
        );
      case "Survey.SendBySMS":
        return (
          <ButtonStyled
            type='button'
            variant='outlined'
            key={action?.actionID}
            onClick={onSendSMSClick}
            startIcon={<SmsIcon />}
            disabled={isButtonDisabled as boolean}
          >
            Enviar SMS
          </ButtonStyled>
        );
      default:
        return null;
    }
  });
};

export default ActionList;

const ButtonStyled = styled(Button)`
  min-width: 200px;
  margin: 0.25rem;
  width: 100%;
`;
